<template>
  <div>
    <div id="Chart3" style="width: 100%; height: 320px"></div>
  </div>
</template>

<script>
export default {
  props:{
    chart3_data_x:{
      type:Array,
      default(){
        return []
      }
    },
    chart3_data_y:{
      type:Array,
      default(){
        return []
      }
    },
    chart3_data_y2:{
      type:Array,
      default(){
        return []
      }
    },
    chart3_data_y3:{
      type:Array,
      default(){
        return []
      }
    },
    chart3_data_y4:{
      type:Array,
      default(){
        return []
      }
    },
    chart3_data_y5:{
      type:Array,
      default(){
        return []
      }
    },
    chart3_data_y6:{
      type:Array,
      default(){
        return []
      }
    },
    chart3_data_data:{
      type:Object,
      default(){
        return {}
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    myEcharts3() {
      var myChart3 = this.$echarts.init(document.getElementById("Chart3"));
      //配置图表
      var option3 = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 25,
          top: 30,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chart3_data_x,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          offset: 24,
          axisLabel: {
            formatter: function (value) {
              return `${value}`
            },
            rich: {
              a: {
                width: 140,
                align: "right",
              },
              b: {
                width: 140,
                align: "left",
              },
            },
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                color: function (e) {
                  if (e > 50) {
                    return "#fd4c4c";
                  } else {
                    return "#fcad2a";
                  }
                },
              },
              formatter: function (value) {
                return value;
              },
            },
            position: "left",
            // min: "dataMin",
            // max: "dataMax",
            // interval: 50,
          },
        ],
        series: [
          {
            name: "股价",
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#fd4c4c",
            data: this.chart3_data_y,
          },
          {
            name: this.chart3_data_data.val1,
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#fcad2a",
            data: this.chart3_data_y2,
          },

          {
            name: this.chart3_data_data.val2,
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#3cbb73",
            data: this.chart3_data_y3,
          },
          {
            name: this.chart3_data_data.val3,
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#7a7ef3",
            data: this.chart3_data_y4,
          },
          {
            name: this.chart3_data_data.val4,
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#fff191",
            data: this.chart3_data_y5,
          },
          {
            name: this.chart3_data_data.val5,
            type: "line",
            smooth: true,
            symbol: "none",
            color: "#aae5a1",
            data: this.chart3_data_y6,
          },
        ],
      };
      myChart3.setOption(option3);
    },
  },
  mounted() {
    // this.myEcharts3();
  },
};
</script>

<style scoped>
</style>